import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { COLORS2 } from '../../../constants';
import { Backdrop, Chip, Link, TextField } from '@material-ui/core';
import { GA_EVENT_TREE } from '../../../gaConstants';
import GoogleIcon from '../../../MyComponents/icons/GoogleIcon';
import FacebookIcon from '../../../MyComponents/icons/FacebookIcon';
import MicrosoftIcon from '../../../MyComponents/icons/MicrosoftIcon';
import Hidden from '@material-ui/core/Hidden';
import GoogleClassroomIcon from '../../../MyComponents/icons/GoogleClassroomIcon';
import userApi from '../../../Api/userApi';
import {
    getGuestTokenForName,
    getStoredGuestNames,
    getValidGuestPayload,
    setGuestToken,
} from '../../../common/guestToken';

const useStyles = makeStyles((theme) => ({
    connectText: {
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '1rem',
        lineHeight: '1.188rem',
        textAlign: 'center',
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        color: '#FFFFFF',
        marginBottom: '2.75rem',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor: 'rgba(2, 35, 37, 0.85)',
    },
    animateInHeader: {
        position: 'absolute',
        top: '0px',
        transition: 'transform 0.4s',
        transform: 'scale(1.3) translate(0vw, 25vh)',
    },
    animateOutHeader: {
        position: 'absolute',
        top: '0px',
        transition: 'transform 0.4s',
        transform: 'scale(1) translate(0vw, 0vh)',
    },
    animateInMain: {
        position: 'absolute',
        bottom: '0px',
        transition: 'transform 0.4s',
        transform: 'scale(1.3) translate(0vw, -40vh)',
    },
    animateOutMain: {
        position: 'absolute',
        bottom: '0px',
        transition: 'transform 0.4s',
        transform: 'scale(1) translate(0vw, 0vh)',
    },
    mobileButton: {
        width: '4rem',
        height: '3.5rem',
        marginRight: '1rem',
        backgroundColor: COLORS2.third,
        borderRadius: '16px',
        boxShadow: '0rem 0rem 0rem 0.5rem rgba(8, 170, 180, 0.08),' + '0rem 2rem 2rem -1rem rgba(6, 81, 86, 0.16)',
        color: COLORS2.nero,
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '0.4rem',
        lineHeight: '0.6rem',
        letterSpacing: '0.1rem',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    tabletButton: {
        width: '5rem',
        height: '4rem',
        marginRight: '1rem',
        backgroundColor: COLORS2.third,
        borderRadius: '16px',
        boxShadow: '0rem 0rem 0rem 0.5rem rgba(8, 170, 180, 0.08),' + '0rem 2rem 2rem -1rem rgba(6, 81, 86, 0.16)',
        color: COLORS2.nero,
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '0.5rem',
        lineHeight: '0.875rem',
        letterSpacing: '0.1rem',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    guestButton: {
        marginTop: '2rem',
        marginLeft: '1.5rem',
        marginRight: '1rem',
        [theme.breakpoints.only('xs')]: {
            marginLeft: '0.25rem',
            marginRight: '0rem',
        },
        minHeight: '3rem',
        padding: '0.5rem 1rem',
        backgroundColor: COLORS2.virtualGreen ?? '#08AAB4',
        borderRadius: '16px',
        boxShadow: '0rem 0rem 0rem 0.5rem rgba(8, 170, 180, 0.08),' + '0rem 2rem 2rem -1rem rgba(6, 81, 86, 0.16)',
        color: '#FFFFFF',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '0.75rem',
        lineHeight: '1.125rem',
        letterSpacing: '0.05rem',
        fontWeight: 700,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    guestForm: {
        backgroundColor: COLORS2.third,
        borderRadius: '16px',
        padding: '2rem',
        maxWidth: '22rem',
        boxShadow: '0rem 0rem 0rem 0.5rem rgba(8, 170, 180, 0.08),' + '0rem 2rem 2rem -1rem rgba(6, 81, 86, 0.16)',
        color: COLORS2.nero,
        display: 'flex',
        flexDirection: 'column',
    },
    guestSubmit: {
        marginTop: '1.5rem',
        height: '3rem',
        backgroundColor: COLORS2.virtualGreen ?? '#08AAB4',
        borderRadius: '16px',
        color: '#FFFFFF',
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '0.75rem',
        letterSpacing: '0.1rem',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    desktopButton: {
        width: '7rem',
        height: '5rem',
        marginRight: '1rem',
        backgroundColor: COLORS2.third,
        borderRadius: '16px',
        boxShadow: '0rem 0rem 0rem 0.5rem rgba(8, 170, 180, 0.08),' + '0rem 2rem 2rem -1rem rgba(6, 81, 86, 0.16)',
        color: COLORS2.nero,
        textAlign: 'center',
        textTransform: 'uppercase',
        fontSize: '0.75rem',
        lineHeight: '0.875rem',
        letterSpacing: '0.1rem',
        fontWeight: 600,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

const SocialButtonDesktop = ({ onClick, textId, icon, isLastInRow }) => {
    let classes = useStyles();

    return (
        <>
            <Hidden only={['xs', 'sm', 'md']}>
                <div style={{ paddingLeft: '1.5rem' }}>
                    <div onClick={onClick} className={classes.desktopButton}>
                        <div>{icon}</div>
                        <div style={{ marginTop: '0.5rem' }}>
                            <FormattedMessage id={textId} />
                        </div>
                    </div>
                </div>
            </Hidden>
            <Hidden only={['xs', 'lg', 'xl']}>
                <div style={{ paddingLeft: '1.5rem' }}>
                    <div onClick={onClick} className={classes.tabletButton}>
                        <div>{icon}</div>
                        <div>
                            <FormattedMessage id={textId} />
                        </div>
                    </div>
                </div>
            </Hidden>
            <Hidden only={['sm', 'md', 'lg', 'xl']}>
                <div style={{ paddingLeft: '0.25rem' }}>
                    <div
                        onClick={onClick}
                        className={classes.mobileButton}
                        style={{ marginRight: isLastInRow ? '0rem' : '1rem' }}
                    >
                        <div>{icon}</div>
                        <div>
                            <FormattedMessage id={textId} />
                        </div>
                    </div>
                </div>
            </Hidden>
        </>
    );
};

const GuestLoginForm = ({ onBack }) => {
    const classes = useStyles();
    const storedGuest = getValidGuestPayload();
    const savedNames = getStoredGuestNames();
    const [name, setName] = React.useState(storedGuest?.name ?? '');
    const [error, setError] = React.useState(null);
    const [submitting, setSubmitting] = React.useState(false);

    const handleSubmit = (submitName) => {
        if (submitting) return;
        // submitName is only a string when a saved-guest chip is clicked; the
        // submit button passes the click event here
        let trimmed = (typeof submitName === 'string' ? submitName : name).trim();
        if (!trimmed) {
            setError('login.guest.nameRequired');
            return;
        }
        setSubmitting(true);
        userApi
            .guestLogin(trimmed, getGuestTokenForName(trimmed))
            .then((res) => {
                setGuestToken(trimmed, res.data.token);
                let existingPath = window.localStorage.getItem('pathBeforeLogin');
                window.localStorage.removeItem('pathBeforeLogin');
                window.location.replace(existingPath || '/');
            })
            .catch((err) => {
                setSubmitting(false);
                setError(err?.response?.status === 400 ? 'login.guest.nameRequired' : 'login.guest.error');
            });
    };

    return (
        <div className={classes.guestForm} onClick={(e) => e.stopPropagation()}>
            <Typography variant='h6' style={{ marginBottom: '0.5rem' }}>
                <FormattedMessage id='login.guest.title' />
            </Typography>
            <ul style={{ margin: '0 0 0.75rem 0', paddingLeft: '1.25rem' }}>
                {['login.guest.info1', 'login.guest.info2', 'login.guest.info3'].map((infoId) => (
                    <li key={infoId}>
                        <Typography variant='caption'>
                            <FormattedMessage id={infoId} />
                        </Typography>
                    </li>
                ))}
            </ul>
            {storedGuest ? (
                <Typography variant='body2' style={{ marginBottom: '0.5rem' }}>
                    <FormattedMessage id='login.guest.welcomeBack' values={{ name: storedGuest.name }} />
                </Typography>
            ) : null}
            {savedNames.length > 1 ? (
                <div style={{ marginBottom: '0.5rem' }}>
                    <Typography variant='caption'>
                        <FormattedMessage id='login.guest.savedGuests' />
                    </Typography>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginTop: '0.25rem' }}>
                        {savedNames.map((savedName) => (
                            <Chip
                                key={savedName}
                                label={savedName}
                                size='small'
                                clickable
                                onClick={() => handleSubmit(savedName)}
                            />
                        ))}
                    </div>
                </div>
            ) : null}
            <TextField
                autoFocus
                value={name}
                onChange={(e) => {
                    setName(e.target.value);
                    setError(null);
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        handleSubmit();
                    }
                }}
                label={<FormattedMessage id='login.guest.nameLabel' />}
                inputProps={{ maxLength: 100 }}
                error={!!error}
                helperText={error ? <FormattedMessage id={error} /> : null}
            />
            <Typography variant='caption' style={{ marginTop: '1rem' }}>
                <FormattedMessage
                    id='login.guest.termsNotice'
                    values={{
                        terms: (
                            <Link href='/terms' target='_blank'>
                                <FormattedMessage id='login.guest.termsLink' />
                            </Link>
                        ),
                        policy: (
                            <Link href='/privacypolicy' target='_blank'>
                                <FormattedMessage id='login.guest.policyLink' />
                            </Link>
                        ),
                    }}
                />
            </Typography>
            <div className={classes.guestSubmit} style={{ opacity: submitting ? 0.6 : 1 }} onClick={handleSubmit}>
                <FormattedMessage id='login.guest.submit' />
            </div>
            <Link
                component='button'
                onClick={onBack}
                style={{ marginTop: '1rem', color: COLORS2.nero, textAlign: 'center' }}
            >
                <FormattedMessage id='login.guest.back' />
            </Link>
        </div>
    );
};

export const ResponsiveLoginModal = ({ handleLogin, handleClose, open, fromHeader = true }) => {
    const classes = useStyles();
    const [guestMode, setGuestMode] = React.useState(false);

    React.useEffect(() => {
        // always reopen on the main sign-in options, not the guest form
        if (!open) {
            setGuestMode(false);
        }
    }, [open]);

    if (window.isTeams) return null;

    if (open && guestMode) {
        return (
            <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
                <GuestLoginForm onBack={() => setGuestMode(false)} />
            </Backdrop>
        );
    }

    return (
        <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
            <div
                className={
                    open
                        ? fromHeader
                            ? classes.animateInHeader
                            : classes.animateInMain
                        : fromHeader
                        ? classes.animateOutHeader
                        : classes.animateOutMain
                }
            >
                <div>
                    <Typography className={classes.connectText}>
                        <FormattedMessage id="redesign.page.home.modal.connect" />
                    </Typography>
                </div>
                <div>
                    <div style={{ display: 'flex' }}>
                        <SocialButtonDesktop
                            onClick={(e) => {
                                window.logAppActivity(GA_EVENT_TREE.mainPage.links.googleLogin);
                                handleLogin('/google');
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            icon={<GoogleIcon />}
                            textId={'home.loginGoogle'}
                            isLastInRow={false}
                        />
                        <SocialButtonDesktop
                            onClick={(e) => {
                                window.logAppActivity(GA_EVENT_TREE.mainPage.links.googleLogin);
                                handleLogin('/google');
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            icon={<GoogleClassroomIcon />}
                            textId={'home.loginGoogleClassroom'}
                            isLastInRow={true}
                        />
                    </div>
                    <div style={{ display: 'flex', marginTop: '2rem' }}>
                        <SocialButtonDesktop
                            onClick={(e) => {
                                window.logAppActivity(GA_EVENT_TREE.mainPage.links.facebookLogin);
                                handleLogin('/facebook');
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            icon={<FacebookIcon />}
                            textId={'home.loginFacebook'}
                            isLastInRow={false}
                        />
                        <SocialButtonDesktop
                            onClick={(e) => {
                                window.logAppActivity(GA_EVENT_TREE.mainPage.links.microsoftLogin);
                                handleLogin('/microsoft');
                                e.preventDefault();
                                e.stopPropagation();
                            }}
                            icon={<MicrosoftIcon />}
                            textId={'home.loginMicrosoft'}
                            isLastInRow={true}
                        />
                    </div>
                    <div
                        className={classes.guestButton}
                        onClick={(e) => {
                            setGuestMode(true);
                            e.preventDefault();
                            e.stopPropagation();
                        }}
                    >
                        <FormattedMessage id='login.guest.continueAsGuest' />
                    </div>
                </div>
            </div>
        </Backdrop>
    );
};
